const initialState = {
  items: [],
  allItems: [],
  itemCache: {}, // new key for category-wise caching
  labelsCache: {},    // new key to store the cache labels
};
const itemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ITEM_SUCCESS":
      return {
        ...state,
        items: action.payload,
      };
    case "FETCH_ALL_ITEMS_SUCCESS":
      return {
        ...state,
        allItems: action.payload,
      };
    case "CACHE_CATEGORY_ITEMS":
      return {
        ...state,
        itemCache: {
          ...state.itemCache,
          [action.payload.key]: action.payload.items,
        },
    };
    case "CACHE_LABELS":        //To cache the labels for each items
      return {
        ...state,
        labelsCache: {
          ...state.labelsCache,
          [action.payload.restaurantID]: action.payload.labels,
        },
    };

    case "ADD_ITEM_SUCCESS":
      return {
        ...state,
        items: [action.payload, ...state.items],
      };
    case "UPDATE_ITEM_SUCCESS":
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item
        ),
      };
    case "DELETE_ITEM_SUCCESS":
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      };
    default:
      return {
        ...state,
      };
  }
};
export default itemsReducer;
